<!--
 * @Author: yuli yuli@cnstrong.cn
 * @Date: 2024-10-17 14:36:57
 * @LastEditors: yuli yuli@cnstrong.cn
 * @LastEditTime: 2024-10-29 10:01:49
 * @FilePath: /fed-doctor-helper-ms/src/views/WorkPlace/Container/chat/components/chatAppoint/ModalTips.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="modal-tips" ref="DOM">
    <a-modal
      v-model:visible="data.visible"
      title="患者存在预约单还未完成，确定修改下次复诊时间吗？"
      @ok="onOk"
      @cancel="onCancel"
      :getContainer="DOM"
      :centered="true"
    >
      <template #title="">
        <div>患者存在预约单还未完成，确定修改下次复诊时间吗？</div>
      </template>
      <div class="content">
        <!-- 修改后 -->
        <div class="item">
          <h6 class="header header-edit">
            <auth-img :height="28" :width="28" :src="icon" alt="followup" />
            <span class="text">修改后的复诊预约</span>
          </h6>
          <div v-if="data.news.date" class="body body-edit">
            <div class="">
              复诊时间：{{ handleTimeShowWeek(data.news.date.split(' ')[0])
              }}{{ data.news.date.split(' ')[1] }}
            </div>
            <div>复诊方式：{{ data.news.method }}</div>
          </div>
          <div v-else class="body body-edit">遵医嘱复诊</div>
        </div>
        <!-- 已经存在 -->
        <div class="item">
          <h6 class="header">已存在的复诊预约</h6>
          <div class="body">
            {{ handleTimeShowWeek(data.cur.date.split(' ')[0]) }}{{ data.cur.date.split(' ')[1] }} |
            {{ data.cur.method }}
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import icon from '@/assets/img/followup.png'
import { message } from 'ant-design-vue'
import { reactive, defineExpose, defineEmits, ref } from 'vue'
import { handleTimeShowWeek } from '@/utils'
const DOM = ref()
const data = reactive({
  visible: false,
  cur: {
    method: '',
    date: ''
  },
  news: {
    method: '',
    date: ''
  }
})
const emits = defineEmits(['onOk'])
function onOk() {
  emits('onOk')
  onCancel()
}
function onCancel() {
  data.visible = false
}
// 打开弹出框 并且初始化
function onOpen(_data) {
  const { news, cur } = _data
  // 有一个没有数据 直接退出
  if (!news || !cur) {
    return message.warning('数据异常')
  }
  data.visible = true
  data.news = {
    method: news.method,
    date: news.date
  }
  data.cur = {
    method: cur.method,
    date: cur.date
  }
}
defineExpose({
  onCancel,
  onOpen
})
</script>
<style lang="scss" scoped>
.modal-tips {
  ::v-deep(.ant-modal-content) {
    background-image: linear-gradient(180deg, #cfd8f6 3%, #dde3f8 46%, #ffffff 81%);
    border-radius: 12px;

    .ant-modal-header {
      background-color: transparent;
      border-bottom: none;
      .ant-modal-title {
      }
    }
    .ant-modal-body {
      padding: 0px 24px 24px;
    }
  }

  .content {
    .item {
      margin-bottom: 12px;
      background-color: white;
      padding: 12px 16px 16px;
      box-shadow: 0 0 16px 0 #dde3f2;
      border-radius: 8px;

      .header {
        font-size: 14px;
        font-weight: 400;
        color: #8b9299;
        margin-bottom: 6px;
        display: flex;
        align-items: center;
      }
      .header-edit {
        margin-bottom: 10px;

        .text {
          font-weight: 500;
          font-size: 16px;
          color: #f84f4f;
          margin-left: 4px;
        }
      }
      .body {
        border-radius: 0 8px 8px 0;

        .text-time {
          margin-bottom: 8px;
        }
      }

      .body-edit {
        padding: 12px 16px;
        border-left: 4px #fb992e solid;
        background-color: rgba(250, 240, 226);
      }

      &:last-child {
        box-shadow: none;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
